import { render, staticRenderFns } from "./Splitter.vue?vue&type=template&id=269baa6f&scoped=true"
import script from "./Splitter.vue?vue&type=script&lang=js"
export * from "./Splitter.vue?vue&type=script&lang=js"
import style0 from "./Splitter.vue?vue&type=style&index=0&id=269baa6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269baa6f",
  null
  
)

export default component.exports